import React, { useEffect, useState } from "react";
import { EAData } from "../../../network/api/EAData";
import CardLoader from "../../../../../components/CardLoader";
import { Link } from "react-router-dom";
import { encodeId } from "../../../../../utils/hash";

export default function EADetailsCard({ eaId, showImage = false, showFooterStats = true, setExpert, expert, setExpertErrorMessages = null, setExpertLoader = null, retry = null, showGButton = false, showEACode = false }) {

    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [reload, setReload] = useState(false);

    useEffect(() => {
        if (setExpertErrorMessages)
            setExpertErrorMessages(errorMessage);
        if (setExpertLoader)
            setExpertLoader(isLoading);

    }, [errorMessage, isLoading, setExpertErrorMessages, setExpertLoader]);

    useEffect(() => {
        const fetchEAData = async () => {
            setIsLoading(true);
            setErrorMessage(null);

            if (!eaId) {
                setIsLoading(false);
                setErrorMessage({ code: 401, message: "No EA found." });
                return;
            }

            try {
                const response = await EAData({ method: "GET", id: eaId });

                if (response.status === "success") {
                    setExpert({
                        ...response.data,
                        metadata: JSON.parse(response.data.metadata || null),
                    });
                    
                } else {
                    setErrorMessage({ code: response.code, message: response.message });
                }
            } catch (err) {
                setErrorMessage({ code: 500, message: err.message || "Failed to load profile." });

            } finally {
                setIsLoading(false);
            }
        };
        if (setExpert) {
            fetchEAData();
        }
    }, [eaId, reload, retry, setExpertErrorMessages, setExpertLoader, setExpert]);

    return (

        <div className="card overflow-hidden">
            {(isLoading || errorMessage) && (<CardLoader type={"primary"} errorMessage={errorMessage} onRetry={() => { setReload(!reload); }} />)}

            {!showImage ?
                <div className="card-header border-0 pb-0">
                    <h2 className="card-title">about EA</h2>
                </div>
                :
                <div className="card-header p-0 ">
                    <div
                        className="bg-light card-body p-0"
                        style={{
                            height: "120px",
                            backgroundImage: `url('${expert?.image_url && expert?.image_url !== "" ? expert?.image_url : "https://online.lemorgan.co.za/wp-content/uploads/2017/06/wood-blog-placeholder.jpg"}')`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                        }}
                    ></div>
                </div>}
            <div className="card-body pb-0">
                <p>{expert?.description}</p>
                <ul className="list-group list-group-flush">
                    {expert?.name && expert?.name.length > 0 ?
                        <li className="list-group-item d-flex px-0 justify-content-between">
                            <strong>Name</strong>
                            <Link to={`/eas/${encodeId(expert?.id)}`} className=" text-primary mb-0">{expert?.name}</Link>
                        </li> : <></>
                    }
                    {expert?.social_url && expert?.social_url.length > 0 ?
                        <li className="list-group-item d-flex px-0 justify-content-between">
                            <strong>Social Link</strong>
                            <a href={expert?.social_url} className=" text-primary mb-0" rel="noreferrer" target="_blank">{expert?.social_url}</a>
                        </li> : <></>
                    }
                    {expert?.color_scheme ?
                        <li className="list-group-item d-flex px-0 justify-content-between">
                            <strong>Color</strong>
                            <span className="mb-0">{expert?.color_scheme}</span>
                        </li> : <></>
                    }
                    {expert?.in_store && JSON.parse(expert?.in_store) === true ?
                        <li className="list-group-item d-flex px-0 justify-content-between">
                            <strong>In store</strong>
                            <span className="mb-0 text-primary"><i className="fas fa-shopping-bag" aria-hidden="true"></i>
                            </span>
                        </li> : <></>
                    }
                    <li className="list-group-item d-flex px-0 justify-content-between">
                        <strong>Date</strong>
                        <span className="mb-0">{new Date(expert?.date).toLocaleDateString(undefined, { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' })}</span>
                    </li>

                    {showEACode ?
                        <li className="list-group-item d-flex px-0 justify-content-between">
                            <strong>EA Code</strong>
                            <span>
                                <h6 className="mb-0 text-danger"><strong>{expert?.secret_code}</strong></h6>
                                <p>NOTE: Do Not to share with anyone.</p>
                            </span>

                            
                        </li> :
                        <></>
                    }

                    {showGButton ?
                        <li className="list-group-item d-flex px-0 justify-content-between">
                            <strong></strong>
                            <Link to={`/eas/${encodeId(expert?.id)}/license/create`} className="btn btn-dark light btn-block btn-sm">Generate License Key</Link>
                        </li>
                        : <></>
                    }
                </ul>
            </div>

            {showFooterStats ?
                <div className="card-footer pt-0 pb-0 text-center">
                    <div className="row">
                        <div className="col-4 pt-3 pb-3 border-end">
                            <h3 className="mb-1 text-primary">150</h3>
                            <span>Symbols</span>
                        </div>
                        <div className="col-4 pt-3 pb-3 border-end">
                            <h3 className="mb-1 text-primary">140</h3>
                            <span>Active Users</span>
                        </div>
                        <div className="col-4 pt-3 pb-3">
                            <h3 className="mb-1 text-primary">45</h3>
                            <span>Total Users</span>
                        </div>
                    </div>
                </div> : <></>}
        </div>

    );

}